const loginAndSignUp = {
  loginTips: "Already have a HitPaw account? <1>Login</1>",
  loginSuccessTips: "Login successful",
  loginErrorTips: "Login failed",
  loginAccountOrPasswordErrorTips: "Your E-mail address or password was incorrect. Please try again.",
  loginAccountNotExitErrorTips: "The E-mail is not registered",
  signUpTips: "Not a registered user yet?",
  rememberMe: "Remember me",
  forgotPassword: "Forgot Password?",
  forgotPasswordTitle: "Forgot Password",
  verifyEmailBtn: "Verify E-mail",
  resetPasswordTitle: "Reset password",
  resetPasswordLabel: "Please reset your password",
  resetPasswordPlaceholder: "Enter a new password",
  resetPasswordSuccessTips: "Password reset successfully",
  signUpPrivacyTips: "By proceeding, you agree to our <1>Services of Use</1> and <3>Privacy Policy</3>.",
  loginPrivacyTips: "By proceeding, you agree to our <1>Services of Use</1> and <3>Privacy Policy</3>.",
  signUpSuccessTips: "Your Account Has Been Registered Successfully！",
  getCode: "Get Code",
  getCodeSuccessTips: "It has been sent to your mailbox , please check it",
  verificationSuccessTips: "E-mail address verification succeeded",
  surveyTitle: "Welcome to HitPaw Online",
  surveyStep1: "<1>Step 1</1>/3",
  surveyStep2: "<1>Step 2</1>/3",
  surveyStep3: "<1>Step 3</1>/3",
  surveyQuestion: "What is your purpose for using HitPaw?",
  surveyThemeQuestion: "Choose the mode you like",
  surveyAnswerOther: "Others",
  surveyAnswer1: "Lifestyle Video",
  surveyAnswer2: "Business Video",
  surveyAnswer3: "Company Video",
  surveyAnswer4: "Marketing Video",
  surveyAnswer5: "Social Media Video",
  surveyAnswer6: "Slideshow Video",
  surveyAnswer7: "Video Tool",
  surveyAnswer8: "Travel Video",
  surveyAnswer9: "Wedding Video",
  surveyAnswer10: "Birthday Video",
  surveyAnswer11: "Baby Video",
  surveyAnswer12: "Animal Video",
  surveyAnswer13: "Food Video",
  surveyAnswer14: "Fashion Video",
  surveyAnswer15: "Holiday Video",
  surveyAnswer16: "Sport Video",
  surveyAnswer17: "Photography Video",
  surveyAnswer18: "Music Video",
  surveyAnswerLightMode: "Light mode",
  surveyAnswerDarkMode: "Dark mode",
  surveyNextBtn: "Next",
  surveyBackBtn: "Back",
  surveyDoneBtn: "Done",
  surveyStartBtn: "Get Started",
  logoutWarnTips: "Are you sure to log out?",
};

export default loginAndSignUp;
